import { z } from 'zod';
/** Reported by GET /api/health. Consumed by the client and by the Docker healthcheck. */
export const healthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    uptimeSeconds: z.number().int().nonnegative(),
    database: z.enum(['up', 'down']),
    /** Server build/release identifier, so a stale client can detect a deploy. */
    version: z.string(),
});
//# sourceMappingURL=health.js.map